import { useSelector } from "react-redux";
import { UserRole, UserType } from "../_statics/UserStatics";
import { useMemo } from "react";
import { OrganizationType } from "../_statics/OrganizationType";

const useUserAuthentication = () => {
    const user = useSelector((state) => state.authentication.user);

    const isSuperUser = useMemo(
        () => user && (user.userRole === UserRole.SUPER_USER || user.userRole === UserRole.TECHNICAL_USER),
        [user]
    );
    const isAdminUser = useMemo(() => user && user.userRole === UserRole.ADMINISTRATOR, [user]);

    const isCustomer = useMemo(() => user && user.platformUserType === UserType.CUSTOMER, [user]);
    const isTaxConsultant = useMemo(() => user && user.platformUserType === UserType.TAXCONSULTANT, [user]);

    const isInAgency = useMemo(() => user && user.inAgency, [user]);

    const isShopifyAppCustomer = useMemo(
        () =>
            user &&
            user.selectedOrganization &&
            user.selectedOrganization.organizationType === OrganizationType.SHOPIFY_APPSTORE,
        [user]
    );

    const selectedOrganization = useMemo(() => {
        if (user) {
            return user.selectedOrganization;
        } else {
            return null;
        }
    }, [user]);

    const selectedOrganizationUUID = useMemo(() => {
        if (selectedOrganization) {
            return selectedOrganization.externalUUID;
        } else {
            return null;
        }
    }, [selectedOrganization]);

    return {
        isSuperUser,
        isAdminUser,

        isCustomer,
        isTaxConsultant,

        isInAgency,
        isShopifyAppCustomer,

        selectedOrganizationUUID,
        selectedOrganization,
    };
};

export default useUserAuthentication;
